/** Published rate on the marketing landing: ₪ per 1,000 video impressions (CPM). */

export const LANDING_CPM_NIS = 15;

/** Reichman (רייכמן) graduate promotion: discounted CPM on /ad/raicman. */
export const RAICMAN_GRADUATE_CPM_NIS = 12;
